import { useMgoClient } from '@mgonetwork/dapp-kit';
import { MgoClient } from '@mgonetwork/mango.js/client';
import { useMemo } from 'react';

import { useNetwork } from '~/context';
import { FullNodeConfigs, Network } from '~/utils/api/DefaultRpcClient';


export function useFullNodeRpcClient() {
	const [network] = useNetwork();

	const fullNodeRpc = useMemo(() => {
		let fullnodde = FullNodeConfigs[network as Network];

		return new MgoClient(fullnodde);
	}, [network]);

	return fullNodeRpc;
}
